import { Color } from '@persona-id/design-tokens';
import { range } from 'lodash';
import { FC, memo, useMemo } from 'react';
import styled from 'styled-components';

import { LAYOUT_COLUMN_TOTAL } from 'dashboard/apps/DashboardLayoutEditor/constants';
import { GridContainer } from 'dashboard/apps/DashboardLayoutEditor/LayoutPreview/LayoutCanvas';

const GridBox = memo(styled('div')<{ column: number; row: number }>`
  border-bottom: 1px solid ${Color.CoreSlate200};
  border-right: 1px solid ${Color.CoreSlate200};

  ${({ row }) => (row === 0 ? `border-top: 1px solid ${Color.CoreSlate200};` : '')}
  ${({ column }) => (column === 0 ? `border-left: 1px solid ${Color.CoreSlate200};` : '')}
`);

interface GridVisualizerProps {
  totalRows: number;
}

export const GridBoxesLayer: FC<GridVisualizerProps> = ({ totalRows }) => {
  // TODO: (melissa) look into a way to do this with fewer nodes
  const gridBoxes = useMemo(() => {
    return range(totalRows).map((rowNum) => {
      return range(LAYOUT_COLUMN_TOTAL).map((colNum) => {
        return (
          <GridBox
            data-test='layout-canvas__grid-overlay--grid-item'
            column={colNum}
            row={rowNum}
            key={`${rowNum}, ${colNum}`}
          />
        );
      });
    });
  }, [totalRows]);

  return (
    <GridContainer rows={totalRows} disablePointerEvents data-test='layout-canvas__grid-overlay'>
      {gridBoxes}
    </GridContainer>
  );
};
